"use client";

import CareersForm from "@/components/careers/CareersForm";
import Footer1 from "@/components/footers/Footer1";
import Header2 from "@/components/headers/Header2";
import Link from "next/link";
import { useEffect } from "react";

export default function CareerPage() {
  useEffect(() => {
    document.title = "Careers || Arena Water Park";
  }, []);

  return (
    <>
      <div
        className="breadcrumb-wrapper bg-cover"
        style={{
          backgroundImage: `url("/assets/img/breadcrumb-bg.jpg")`,
        }}
      >
        <div className="shape-image float-bob-y"></div>

        <div className="container">
          <div className="breadcrumb-wrapper-items">
            <div className="page-heading">
              <div className="breadcrumb-sub-title">
                <h1 className="wow fadeInUp" data-wow-delay=".3s">
                  {"Careers"}
                </h1>
              </div>

              <ul
                className="breadcrumb-items wow fadeInUp"
                data-wow-delay=".5s"
              >
                <li>
                  <Link href="/">Home</Link>
                </li>
                <li>
                  <i className="fa-sharp fa-solid fa-slash-forward" />
                </li>
                <li>Careers</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className="container py-5">
        <div className="row justify-content-center">
          <div className="col-lg-8">
            <div className="card shadow-sm border-0 mb-4">
              <div className="card-body p-4">
                <span className="movies-mini-title">
                  <span className="mini-dot"></span>Join Our Team
                </span>
                <h2 className="mb-3" style={{ fontSize: "35px" }}>
                  Start your journey at Arena Water Park!
                </h2>
                <p className="lead text-muted">
                  "We're looking for passionate individuals to join our team and create unforgettable experiences for our guests. If you love fun, adventure, and providing excellent service, we want to hear from you."
                </p>
                <hr />
                <div className="mt-4">
                  <h5>Why Work With Us?</h5>
                  <ul className="list-unstyled mt-3">
                    <li className="mb-2"><i className="fa-solid fa-check text-primary me-2"></i> Exciting and dynamic work environment</li>
                    <li className="mb-2"><i className="fa-solid fa-check text-primary me-2"></i> Opportunities for growth and development</li>
                    <li className="mb-2"><i className="fa-solid fa-check text-primary me-2"></i> Be part of a team that creates happiness</li>
                  </ul>
                </div>
              </div>
            </div>
            
            <div className="card shadow-sm border-0">
              <div className="card-body p-0">
                <CareersForm />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
